import '@/stylesheet/main.css'
import "vue-toastification/dist/index.css";
import 'bootstrap'
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery';
/* import font awesome icon component */
import Toast from "vue-toastification";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import fontAwesomeIcons from "@/utilities/font-awesome-icons";
import { createPinia } from "pinia";
import '@vuepic/vue-datepicker/dist/main.css'
import { VueDatePicker } from '@vuepic/vue-datepicker';

window.$ = $
fontAwesomeIcons()
const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('VueDatePicker', VueDatePicker);
app.use(Toast, { maxToasts: 3 })
app.use(createPinia())
app.use(router)
app.mount('#app')
